import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { MODAL_CLOSE } from 'redux/slices/modals';

import { Icon, Button } from 'ui/atoms';
import { Container } from 'ui/gridSystem';
import MainFont from 'ui/typography/mainFont';

import {
  IconClose,
  ModalGlobalContainer,
  ModalTitle,
  ModalWrapper
} from '../Modal.style';

import { Buttons, ModalContainer, ModalContent, ModalHeader } from './style';

import Modal, { stopEvent } from '../Modal';

const modalId = 'DeletePreference';

const DeletePreferenceModal = ({ onClose, setConfirmed, payload }) => {
  const { t } = useTranslation();
  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer
            onMouseDown={stopEvent}
            onClick={stopEvent}
            width="791px"
            height="auto"
          >
            <ModalTitle>
              <MainFont type="4" configuration={{ fontSize: 24 }}>
                {t('delete_preference_title')}
              </MainFont>
              <IconClose>
                <Icon type="icon-close-modal" size={20} onClick={onClose} />
              </IconClose>
            </ModalTitle>
            <ModalContainer>
              <ModalContent>
                <ModalHeader>
                  <MainFont type="description" configuration={{ fontSize: 16 }}>
                    {t('delete_preference_text')}
                  </MainFont>
                </ModalHeader>
              </ModalContent>
            </ModalContainer>
            <Buttons>
              <Button variant="popupCancel" onClick={() => onClose()}>
                {t('no_wait')}
              </Button>
              <Button
                variant="popupYes"
                onClick={() => {
                  payload.confirmDelete();
                  onClose();
                }}
              >
                {t('delete_confirm')}
              </Button>
            </Buttons>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

DeletePreferenceModal.propTypes = {
  onClose: PropTypes.func || PropTypes.string
};

DeletePreferenceModal.id = modalId;

export default connect(
  state => ({
    payload: state.modals?.payload
  }),
  dispatch => ({
    onClose: () => dispatch(MODAL_CLOSE())
  })
)(DeletePreferenceModal);
